import React from "react";
import { X, Download } from "lucide-react";
import FileViewer from "../../../components/global/FileViewer";
import { saveAs } from "file-saver";
import { getFileIcon, getFileType } from "../utils/fileUtils";

export function FileViewerModal({ file, onClose, backendUrl }) {
  const [previewUrl, setPreviewUrl] = React.useState(null);
  const fileName = file.url.url.split("/").pop() || "file";
  const fileType = getFileType(fileName);

  React.useEffect(() => {
    setPreviewUrl(file.url.url);
  }, [file.url]);

  const handleDownload = async () => {
    const name = file.name;
    const url = file.url.url;
    const fileUrl = `${backendUrl}${url}`;
    saveAs(fileUrl, name);
  };

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  React.useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === "Escape") {
        onClose();
      }
    };

    document.addEventListener("keydown", handleEscape);
    return () => document.removeEventListener("keydown", handleEscape);
  }, [onClose]);

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm "
      onClick={handleBackdropClick}
    >
      <div className="relative w-full max-w-7xl 	bg-white rounded-xl shadow-2xl ">
        <div className="flex items-center justify-between p-4 border-b ">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-lg bg-gray-50 border border-gray-200 flex items-center justify-center text-gray-500">
              {getFileIcon(fileType)}
            </div>
            <div>
              <h3 className="font-medium text-gray-900">{file.name}</h3>
              <p className="text-sm text-gray-500">
                {getFileTypeLabel(file.type)}
              </p>
            </div>
          </div>
          <div className="flex items-center gap-2">
            <button
              onClick={handleDownload}
              className="p-2 text-gray-500 hover:text-blue-500 hover:bg-blue-50 rounded-lg transition-colors"
              title="Download file"
            >
              <Download size={20} />
            </button>
            <button
              onClick={onClose}
              className="p-2 text-gray-500 hover:text-red-500 hover:bg-red-50 rounded-lg transition-colors"
              title="Close"
            >
              <X size={20} />
            </button>
          </div>
        </div>

        <div className="p-4  overflow-auto">
          <FileViewer url={`${backendUrl}${previewUrl}`} fileType={file.type} />
        </div>
      </div>
    </div>
  );
}

function getFileTypeLabel(type) {
  if (type.startsWith("image/")) return "Image";
  if (type === "application/pdf") return "PDF Document";
  if (type === "application/msword") return "Word Document";
  if (type === "text/plain") return "Text Document";
  if (type === "application/rtf") return "Rich Text Document";
  if (type === "application/zip") return "ZIP Archive";
  if (type === "application/x-rar-compressed") return "RAR Archive";
  if (type === "application/x-7z-compressed") return "7Z Archive";
  if (type.startsWith("video/")) return "Video";
  return "File";
}
